// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#messages {
  position: absolute;
  right: 0;
  top: 150px;
  width: 350px;
  z-index: 10;
}

#messages .message {
  -webkit-border-top-left-radius: 5px;
  -webkit-border-bottom-left-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -moz-border-radius-bottomleft: 5px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: #fff;
  border: 2px solid #1eabe3;
  border-right: none;
  margin-bottom: 10px;
  padding: 15px;
  position: relative;
}

#messages .message h3 {
  font-size: 14px;
  margin: 0px;
  padding: 0px 0px 7px;
}

#messages .message p {
  font-size: 11px;
}

#messages .message .closer {
  background: #f00;
  border: 1px solid #f00;
  color: #fff;
  left: -12px;
  top: -12px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/messages.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,UAAU;AACZ","sourcesContent":["#messages {\n  position: absolute;\n  right: 0;\n  top: 150px;\n  width: 350px;\n  z-index: 10;\n}\n\n#messages .message {\n  -webkit-border-top-left-radius: 5px;\n  -webkit-border-bottom-left-radius: 5px;\n  -moz-border-radius-topleft: 5px;\n  -moz-border-radius-bottomleft: 5px;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  background-color: #fff;\n  border: 2px solid #1eabe3;\n  border-right: none;\n  margin-bottom: 10px;\n  padding: 15px;\n  position: relative;\n}\n\n#messages .message h3 {\n  font-size: 14px;\n  margin: 0px;\n  padding: 0px 0px 7px;\n}\n\n#messages .message p {\n  font-size: 11px;\n}\n\n#messages .message .closer {\n  background: #f00;\n  border: 1px solid #f00;\n  color: #fff;\n  left: -12px;\n  top: -12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
